export const M6_UNIT_8 = {
  id: "m6-u8-life-experiences",
  title: "Unidad 8: Life Experiences & Travel",
  topic: "Talk about your life! Share travel experiences, adventures, and amazing things you've done. Master 'Have you ever...?' conversations like a native!",
  iconType: "globe",
  grammarImage: "/grammar/grammar-m6-u8.jpg",
  grammarText: "Present Perfect for life experiences (Have you ever...?) + Past Simple for details (When did you...?). Learn BEEN vs GONE. Essential for travel conversations!",
  sets: [

    // ===================================================================
    // SET 1: HAVE YOU EVER...? - LIFE EXPERIENCES (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s1",
      title: "Set 1: Have You Ever...?",
      questions: [
        {
          type: "mc",
          q: "Asking about someone's life experiences: '___  you ever been to Europe?'",
          options: ["Have", "Did", "Are"],
          a: "Have",
          tip: "Life experiences = HAVE EVER + past participle",
          successtip: "✓HAVE YOU EVER!\nLos nativos usan esto TODO el tiempo para preguntar experiencias 🌍\nNunca 'Did you ever' ❌"
        },
        {
          type: "order",
          q: "Context: Preguntando si alguien ha probado comida japonesa alguna vez. Traduce: ¿Alguna vez has probado comida japonesa?",
          words: ["Have", "you", "ever", "tried", "Japanese", "food?"],
          a: "Have you ever tried Japanese food?",
          tip: "EVER = alguna vez (en tu vida)",
          successtip: "✓TRY!\nPara comida, nativos dicen 'try' o 'have', nunca 'eat' en esta pregunta 🍣"
        },
        {
          type: "input",
          q: "'___ you ever been skydiving?' (asking about life experience)",
          a: "Have",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓SKYDIVING!\nSkydiving = salto en paracaídas 🪂\nTOP extreme sport question!"
        },
        {
          type: "mc",
          q: "Your friend asks about your experiences. Natural question:",
          options: ["Have you ever been to a music festival?", "Did you ever go to a music festival?", "Are you ever at a music festival?"],
          a: "Have you ever been to a music festival?",
          successtip: "✓MUSIC FESTIVAL!\nFestival = experiencia MUST en países de habla inglesa 🎵\nCoachella, Glastonbury, Lollapalooza..."
        },
        {
          type: "order",
          q: "Context: Preguntando sobre buceo. Traduce: ¿Alguna vez has buceado?",
          words: ["Have", "you", "ever", "gone", "scuba", "diving?"],
          a: "Have you ever gone scuba diving?",
          tip: "GONE scuba diving (not 'been')",
          successtip: "✓SCUBA DIVING!\nScuba = buceo con tanque 🤿\nAsí se dice, no preguntes 💯"
        },
        {
          type: "mc",
          q: "Pattern: 'Have you ever ___?' uses:",
          options: ["past participle (been/done/tried)", "base verb (be/do/try)", "past simple (was/did/tried)"],
          a: "past participle (been/done/tried)",
          tip: "HAVE EVER + PAST PARTICIPLE"
        },
        {
          type: "input",
          q: "Travel question: 'Have you ___ been abroad?' (alguna vez)",
          a: "ever",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓ABROAD!\nAbroad = al extranjero ✈️\nSuper común en conversaciones de viajes"
        },
        {
          type: "order",
          q: "Context: Preguntando sobre montaña rusa. Traduce: ¿Alguna vez te has subido a una montaña rusa?",
          words: ["Have", "you", "ever", "ridden", "a", "roller", "coaster?"],
          a: "Have you ever ridden a roller coaster?",
          tip: "RIDE → RIDDEN (irregular!)",
          successtip: "✓ROLLER COASTER!\nRide = montar/subirse 🎢\nRide → rode → ridden"
        },
        {
          type: "mc",
          q: "'Have you ever seen the Northern Lights?' means:",
          options: ["In your whole life, did you see them? (any time)", "Did you see them yesterday?", "Are you seeing them now?"],
          a: "In your whole life, did you see them? (any time)",
          successtip: "✓NORTHERN LIGHTS!\nAurora boreal 🌌\nBucket list item para nativos!"
        },
        {
          type: "match",
          q: "Match experience questions",
          pairs: [
            { left: "Travel", right: "Have you ever been abroad?" },
            { left: "Food", right: "Have you ever tried sushi?" },
            { left: "Adventure", right: "Have you ever gone bungee jumping?" }
          ],
          a: "completed",
          successtip: "✓BUNGEE JUMPING!\nBungee = bungee 🪢\nOtro extreme sport clásico"
        }
      ]
    },

    // ===================================================================
    // SET 2: YES/NO ANSWERS + FOLLOW-UP (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s2",
      title: "Set 2: Answering Experience Questions",
      questions: [
        {
          type: "mc",
          q: "'Have you ever been to Thailand?' Answer YES:",
          options: ["Yes, I have.", "Yes, I did.", "Yes, I went."],
          a: "Yes, I have.",
          tip: "SHORT ANSWER: Yes/No + subject + have/has",
          successtip: "✓YES, I HAVE!\nNativos casi siempre usan la forma corta, no repiten todo 👍"
        },
        {
          type: "order",
          q: "Context: Respondiendo negativamente sobre paracaidismo. Traduce: No, nunca lo he hecho.",
          words: ["No,", "I", "never", "have."],
          a: "No, I never have.",
          tip: "NEVER = nunca (strong negative)",
          successtip: "✓NEVER!\n'I never have' es más enfático que 'I haven't' 💪\nMuestra que JAMÁS lo has hecho"
        },
        {
          type: "mc",
          q: "After 'Yes, I have', natural follow-up question:",
          options: ["When did you go?", "When have you gone?", "When are you going?"],
          a: "When did you go?",
          tip: "Follow-up = PAST SIMPLE (asking for details!)",
          successtip: "✓FLUJO NATURAL!\nPerfect para experiencia → Simple para detalles\nASÍ hablan los nativos, siempre 🎯"
        },
        {
          type: "input",
          q: "'Have you ever been camping?' 'Yes, I ___.' (short answer)",
          a: "have",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓CAMPING!\nCamping = acampar 🏕️\nActivity MUY popular en US/Canada/Australia"
        },
        {
          type: "order",
          q: "Context: Alguien pregunta detalles después de tu respuesta. Traduce: ¿Cuándo fuiste?",
          words: ["When", "did", "you", "go?"],
          a: "When did you go?",
          tip: "Details = PAST SIMPLE with DID"
        },
        {
          type: "mc",
          q: "'Have you ever seen a Broadway show?' 'No, ___'",
          options: ["I haven't.", "I didn't.", "I not have."],
          a: "I haven't.",
          successtip: "✓BROADWAY!\nBroadway = teatro en NYC 🎭\nLos nativos ponen esto en bucket lists"
        },
        {
          type: "input",
          q: "Natural conversation: 'Have you ever tried surfing?' 'Yes, I have. I ___ it in Hawaii.' (past simple)",
          a: "tried",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓SURFING!\nSurfing = surf 🏄\nHawaii = Meca del surf para nativos"
        },
        {
          type: "order",
          q: "Context: Explicando cuándo visitaste. Traduce: Fui el año pasado.",
          words: ["I", "went", "last", "year."],
          a: "I went last year.",
          tip: "Specific time = PAST SIMPLE (not perfect)",
          successtip: "✓LAST YEAR!\nTiempo específico → Simple SIEMPRE ✓\nNunca 'I have gone last year' ❌"
        },
        {
          type: "mc",
          q: "ERROR CHECK: Which is WRONG?",
          options: ["I have been there last summer.", "I went there last summer.", "I've been there before."],
          a: "I have been there last summer.",
          tip: "⚠️ NEVER Present Perfect + specific time!",
          successtip: "🚨 ERROR COMÚN!\nPerfect + tiempo específico = ERROR\nSimple + tiempo específico = CORRECTO ✓"
        },
        {
          type: "match",
          q: "Match question type to tense",
          pairs: [
            { left: "Have you ever...?", right: "Present Perfect (experience)" },
            { left: "When did you...?", right: "Past Simple (details)" },
            { left: "How was it?", right: "Past Simple (description)" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 3: BEEN vs GONE - CRITICAL! (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s3",
      title: "Set 3: BEEN vs GONE",
      questions: [
        {
          type: "mc",
          q: "'I've been to Paris' means:",
          options: ["I visited and came back (I have the experience)", "I'm in Paris now", "I will go to Paris"],
          a: "I visited and came back (I have the experience)",
          tip: "BEEN = went and returned (experience)",
          successtip: "✓BEEN TO!\nBeen = fuiste y volviste ✈️↩️\nTienes la EXPERIENCIA ahora 🎯"
        },
        {
          type: "mc",
          q: "'She's gone to Paris' means:",
          options: ["She's in Paris now (hasn't returned)", "She visited Paris before", "She wants to go to Paris"],
          a: "She's in Paris now (hasn't returned)",
          tip: "GONE = went and is still there!",
          successtip: "✓GONE TO!\nGone = fue y AÚN está allá 🚫↩️\nNo ha regresado todavía"
        },
        {
          type: "order",
          q: "Context: Tienes la experiencia de visitar Japón (ya regresaste). Traduce: He estado en Japón.",
          words: ["I've", "been", "to", "Japan."],
          a: "I've been to Japan.",
          tip: "Experience (you're here now) = BEEN"
        },
        {
          type: "mc",
          q: "'Where's Tom?' 'He's ___ to the store.' (he's not here now)",
          options: ["gone", "been", "went"],
          a: "gone",
          tip: "Not here = GONE (still there)",
          successtip: "✓GONE!\nSi la persona NO ESTÁ = gone siempre 💯\nAsí es, no preguntes"
        },
        {
          type: "order",
          q: "Context: Tu hermana está en México de vacaciones ahora. Traduce: Ella se ha ido a México.",
          words: ["She's", "gone", "to", "Mexico."],
          a: "She's gone to Mexico.",
          tip: "Still there = GONE TO",
          successtip: "✓AUSENCIA!\nGone = explica por qué alguien NO ESTÁ 🚫"
        },
        {
          type: "input",
          q: "'I've ___ to Thailand three times.' (experience, you're here now)",
          a: "been",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "'Have you ever been to Australia?' vs 'Has she gone to Australia?'",
          options: ["First = asking experience. Second = asking location now.", "Both ask the same thing.", "First asks location, second asks experience."],
          a: "First = asking experience. Second = asking location now.",
          successtip: "✓DOS PREGUNTAS DIFERENTES!\nBeen = ¿tienes experiencia? 🎯\nGone = ¿está allá? 📍"
        },
        {
          type: "order",
          q: "Context: Tus padres están de viaje en Europa. Traduce: Ellos se han ido a Europa.",
          words: ["They've", "gone", "to", "Europe."],
          a: "They've gone to Europe.",
          tip: "Away now = GONE"
        },
        {
          type: "mc",
          q: "ERROR: 'I've gone to Paris twice.' What's wrong?",
          options: ["Should be BEEN (you're here, not there!)", "Nothing wrong", "Should be WENT"],
          a: "Should be BEEN (you're here, not there!)",
          tip: "⚠️ You can't say 'I've gone' if you're HERE!",
          successtip: "🚨 LÓGICO!\nGone = estás ALLÁ\nSi estás AQUÍ hablando = been ✓\nPunto 💯"
        },
        {
          type: "match",
          q: "Match situations to BEEN or GONE",
          pairs: [
            { left: "Talking about your trip last year", right: "I've been to..." },
            { left: "Friend asks where Tom is", right: "He's gone to..." },
            { left: "Counting countries you visited", right: "I've been to..." }
          ],
          a: "completed",
          successtip: "✓BEEN = EXPERIENCIA\nGONE = UBICACIÓN\nEso es todo 🎯"
        }
      ]
    },

    // ===================================================================
    // SET 4: PERFECT → SIMPLE FLOW (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s4",
      title: "Set 4: Experience to Details",
      questions: [
        {
          type: "mc",
          q: "Natural conversation flow: 'Have you been to Bali?' 'Yes!' Next question:",
          options: ["How was it? / When did you go?", "How has it been? / When have you gone?", "How is it? / When do you go?"],
          a: "How was it? / When did you go?",
          tip: "Details = PAST SIMPLE (was/did)",
          successtip: "✓CONVERSACIÓN NATURAL!\nPerfect abre → Simple desarrolla\nLos nativos hacen esto sin pensar 🗣️"
        },
        {
          type: "order",
          q: "Context: Preguntando opinión sobre experiencia pasada. Traduce: ¿Cómo estuvo?",
          words: ["How", "was", "it?"],
          a: "How was it?",
          tip: "Opinion about past = WAS",
          successtip: "✓HOW WAS IT!\nPregunta #1 después de 'Yes, I have' 👍\nSiempre Past Simple para detalles"
        },
        {
          type: "mc",
          q: "A: 'I've been to Iceland.' B: 'Really? What ___ you do there?'",
          options: ["did", "have", "are"],
          a: "did",
          tip: "Asking about specific actions = DID",
          successtip: "✓ICELAND!\nIslandia = trending destination 🇮🇸\nNorthern lights, glaciers, hot springs"
        },
        {
          type: "input",
          q: "A: 'I've tried bungee jumping.' B: 'Where ___ you try it?' (past simple)",
          a: "did",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "order",
          q: "Context: Conversación natural sobre viaje. Traduce: ¿Cuánto tiempo te quedaste?",
          words: ["How", "long", "did", "you", "stay?"],
          a: "How long did you stay?",
          tip: "Duration in past = DID + stay",
          successtip: "✓STAY!\nStay = quedarse (tiempo) ⏰\nQuick visit = days. Long trip = weeks/months"
        },
        {
          type: "mc",
          q: "A: 'Have you ever been to a theme park?' B: 'Yes!' A: 'Which one ___?'",
          options: ["did you go to?", "have you gone to?", "have you been to?"],
          a: "did you go to?",
          tip: "Asking which specific one = PAST SIMPLE",
          successtip: "✓THEME PARK!\nTheme park = parque temático 🎢\nDisney, Universal, Six Flags..."
        },
        {
          type: "input",
          q: "A: 'I've seen a concert.' B: 'Who ___ you see?' (asking specific artist)",
          a: "did",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓CONCERT!\nConcert = concierto 🎤\nBig part of Anglo culture"
        },
        {
          type: "order",
          q: "Context: Preguntando compañía en viaje. Traduce: ¿Con quién fuiste?",
          words: ["Who", "did", "you", "go", "with?"],
          a: "Who did you go with?",
          tip: "Specific travel companion = PAST SIMPLE"
        },
        {
          type: "mc",
          q: "Pattern: Present Perfect asks IF you have experience. Past Simple asks:",
          options: ["Details: when, where, how, who, what", "If you have experience too", "About future plans"],
          a: "Details: when, where, how, who, what",
          successtip: "✓PATTERN MAESTRO!\nPerfect = ¿lo has hecho? ✓\nSimple = cuéntame más 📖\nSiempre así 💯"
        },
        {
          type: "match",
          q: "Match Perfect questions to Simple follow-ups",
          pairs: [
            { left: "Have you been there?", right: "When did you go?" },
            { left: "Have you tried it?", right: "How was it?" },
            { left: "Have you seen him?", right: "Where did you see him?" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 5: VACATION VOCABULARY (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s5",
      title: "Set 5: Vacation Talk",
      questions: [
        {
          type: "mc",
          q: "'I've been on a ___' = vacation on a ship that visits multiple destinations",
          options: ["cruise", "road trip", "flight"],
          a: "cruise",
          tip: "Cruise = ship vacation with stops",
          successtip: "✓CRUISE!\nCruise = crucero 🚢\nCaribbean cruises = súper populares con americanos"
        },
        {
          type: "order",
          q: "Context: Has viajado con mochila por Europa. Traduce: He viajado con mochila por Europa.",
          words: ["I've", "backpacked", "through", "Europe."],
          a: "I've backpacked through Europe.",
          tip: "BACKPACK = travel with backpack (budget style)",
          successtip: "✓BACKPACKING!\nBackpack = mochilero 🎒\nYoung travelers do this en Europa/Asia"
        },
        {
          type: "input",
          q: "'Have you ever stayed at an all-___ resort?' (includes everything)",
          a: "inclusive",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓ALL-INCLUSIVE!\nAll-inclusive = todo incluido 🏖️\nMeals, drinks, activities = one price"
        },
        {
          type: "mc",
          q: "Vacation type: driving long distances, stopping at different places:",
          options: ["road trip", "cruise", "beach vacation"],
          a: "road trip",
          successtip: "✓ROAD TRIP!\nRoad trip = viaje por carretera 🚗\nVERY American/Canadian thing\nRoute 66, Pacific Coast Highway..."
        },
        {
          type: "order",
          q: "Context: Fuiste a resort de playa en Cancún. Traduce: Fui a un resort de playa en Cancún.",
          words: ["I", "went", "to", "a", "beach", "resort", "in", "Cancun."],
          a: "I went to a beach resort in Cancun.",
          tip: "Specific trip = PAST SIMPLE",
          successtip: "✓BEACH RESORT!\nResort = complejo turístico 🌴\nCancún/Punta Cana = top para norteamericanos"
        },
        {
          type: "mc",
          q: "'I've been to a ___ park.' (water slides and pools)",
          options: ["water", "theme", "national"],
          a: "water",
          successtip: "✓WATER PARK!\nWater park = parque acuático 💦\nSlides, wave pools, lazy river..."
        },
        {
          type: "input",
          q: "Luxury vacation: 'We stayed at a five-___ hotel.'",
          a: "star",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓FIVE-STAR!\nFive-star = cinco estrellas ⭐⭐⭐⭐⭐\nLuxury rating system mundial"
        },
        {
          type: "order",
          q: "Context: Visitaste parque nacional. Traduce: Visitamos un parque nacional.",
          words: ["We", "visited", "a", "national", "park."],
          a: "We visited a national park.",
          successtip: "✓NATIONAL PARK!\nNational park = parque nacional 🏞️\nUS tiene 63 (Yellowstone, Yosemite, Grand Canyon...)\nCanadá, Australia, etc = también"
        },
        {
          type: "mc",
          q: "Budget travel style with hostels and local transport:",
          options: ["backpacking", "cruising", "resort vacation"],
          a: "backpacking",
          successtip: "✓HOSTEL!\nHostel = albergue 🛏️\nBackpackers stay here (cheap!)\nVs hotel (expensive)"
        },
        {
          type: "match",
          q: "Match vacation types to descriptions",
          pairs: [
            { left: "Cruise", right: "Ship visiting ports" },
            { left: "Road trip", right: "Driving adventure" },
            { left: "All-inclusive", right: "Everything included resort" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 6: EXTREME SPORTS & ADVENTURE (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s6",
      title: "Set 6: Extreme Adventures",
      questions: [
        {
          type: "mc",
          q: "'Have you ever been ___?' (jumping from plane with parachute)",
          options: ["skydiving", "scuba diving", "bungee jumping"],
          a: "skydiving",
          successtip: "✓SKYDIVING!\nSkydiving = paracaidismo 🪂\nBucket list #1 para muchos nativos\n14,000 feet = typical jump height"
        },
        {
          type: "order",
          q: "Context: Has hecho bungee. Traduce: He hecho bungee jumping.",
          words: ["I've", "been", "bungee", "jumping."],
          a: "I've been bungee jumping.",
          tip: "BEEN + activity-ing (not gone)",
          successtip: "✓BUNGEE!\nBungee = salto con cuerda elástica 🪢\nNew Zealand = birthplace of commercial bungee"
        },
        {
          type: "input",
          q: "'I've gone ___ diving in the Great Barrier Reef.' (underwater breathing)",
          a: "scuba",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓SCUBA!\nSCUBA = Self-Contained Underwater Breathing Apparatus 🤿\nGreat Barrier Reef = top destination mundial"
        },
        {
          type: "mc",
          q: "Adventure activity: climbing up rock faces with ropes and gear:",
          options: ["rock climbing", "hiking", "surfing"],
          a: "rock climbing",
          successtip: "✓ROCK CLIMBING!\nRock climbing = escalada en roca 🧗\nIndoor (gym) or outdoor (real rocks)\nYosemite = famous for this"
        },
        {
          type: "order",
          q: "Context: Has volado en parapente. Traduce: He volado en parapente.",
          words: ["I've", "been", "paragliding."],
          a: "I've been paragliding.",
          successtip: "✓PARAGLIDING!\nParagliding = parapente 🪂\nDifferent from skydiving!\nYou glide, not free fall"
        },
        {
          type: "mc",
          q: "'I've tried ___' (standing on board, ocean waves):",
          options: ["surfing", "skiing", "skating"],
          a: "surfing",
          successtip: "✓SURFING!\nSurfing = surf 🏄\nHawaii, California, Australia = surf culture\n'Surf's up!' = waves are good"
        },
        {
          type: "input",
          q: "Mountain adventure: 'Have you ever been ___ climbing?' (ice/mountains)",
          a: "mountain",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["ice"] },
          successtip: "✓MOUNTAIN CLIMBING!\nMountain/ice climbing = alpinismo ⛰️\nEverest = ultimate goal\nNot same as hiking!"
        },
        {
          type: "order",
          q: "Context: Has hecho rafting en río. Traduce: He hecho rafting en aguas bravas.",
          words: ["I've", "been", "white-water", "rafting."],
          a: "I've been white-water rafting.",
          successtip: "✓WHITE-WATER RAFTING!\nWhite-water = aguas bravas 🚣\nRafting = inflatable boat, rapids\nColorado River = famous spot"
        },
        {
          type: "mc",
          q: "Ocean activity with board, sail, and wind:",
          options: ["windsurfing", "surfing", "sailing"],
          a: "windsurfing",
          successtip: "✓WINDSURFING!\nWindsurfing = windsurf 🏄‍♂️💨\nSurfboard + sail\nNeeds wind + waves"
        },
        {
          type: "match",
          q: "Match extreme sports to elements",
          pairs: [
            { left: "Skydiving", right: "Plane + parachute" },
            { left: "Scuba diving", right: "Underwater + tank" },
            { left: "Rock climbing", right: "Rocks + ropes" }
          ],
          a: "completed",
          successtip: "✓ADRENALINE!\nTodas son 'adrenaline rush' activities 💪\nNativos AMAN hablar de esto"
        }
      ]
    },

    // ===================================================================
    // SET 7: CULTURAL EXPERIENCES (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s7",
      title: "Set 7: Culture & Entertainment",
      questions: [
        {
          type: "mc",
          q: "'Have you ever been to a live ___?' (musical performance)",
          options: ["concert", "movie", "restaurant"],
          a: "concert",
          successtip: "✓LIVE CONCERT!\nLive = en vivo 🎤\nStadium concerts, arena shows, small venues...\nBIG part of cultura anglosajona"
        },
        {
          type: "order",
          q: "Context: Has visto obra de teatro. Traduce: He visto una obra de teatro.",
          words: ["I've", "seen", "a", "theater", "show."],
          a: "I've seen a theater show.",
          tip: "SEE a show (not watch)",
          successtip: "✓THEATER SHOW!\n🇺🇸 'Theater'\n🇬🇧 'Theatre'\nBroadway (NYC), West End (London) = famous"
        },
        {
          type: "input",
          q: "'I visited an art ___ in Paris.' (place displaying art)",
          a: "gallery",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["museum"] },
          successtip: "✓ART GALLERY!\nGallery = galería 🎨\nGallery (private/commercial)\nMuseum (public/historical)\nBoth common!"
        },
        {
          type: "mc",
          q: "Large public event with music, food, activities:",
          options: ["festival", "concert", "museum"],
          a: "festival",
          successtip: "✓FESTIVAL!\nFestival = festival 🎉\nMusic festivals, food festivals, cultural festivals...\nCoachella, SXSW, Burning Man..."
        },
        {
          type: "order",
          q: "Context: Fuiste a exposición de arte moderno. Traduce: Fui a una exposición de arte moderno.",
          words: ["I", "went", "to", "a", "modern", "art", "exhibition."],
          a: "I went to a modern art exhibition.",
          successtip: "✓EXHIBITION!\nExhibition = exposición 🖼️\nMore formal than 'show'\nMuseums hold exhibitions"
        },
        {
          type: "mc",
          q: "Building displaying historical/scientific objects:",
          options: ["museum", "theater", "stadium"],
          a: "museum",
          successtip: "✓MUSEUM!\nMuseum = museo 🏛️\nArt museums, history museums, science museums...\nSmithsonian (DC), Louvre (Paris), British Museum (London)"
        },
        {
          type: "input",
          q: "'Have you been to an amusement ___?' (rides and attractions)",
          a: "park",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓AMUSEMENT PARK!\nAmusement park = parque de diversiones 🎡\nRoller coasters, ferris wheel, games...\nDisneyland, Six Flags, Cedar Point..."
        },
        {
          type: "order",
          q: "Context: Asististe a ópera. Traduce: Fui a la ópera.",
          words: ["I", "went", "to", "the", "opera."],
          a: "I went to the opera.",
          successtip: "✓OPERA!\nOpera = ópera 🎭\nMetropolitan Opera (NYC), La Scala (Milan)...\nMore formal/traditional entertainment"
        },
        {
          type: "mc",
          q: "Outdoor movie experience: 'I've been to a drive-in ___'",
          options: ["theater", "concert", "festival"],
          a: "theater",
          successtip: "✓DRIVE-IN!\nDrive-in theater = autocine 🚗🎬\nWatch movies from your car!\nNostalgia americana, fewer now"
        },
        {
          type: "match",
          q: "Match cultural venues to activities",
          pairs: [
            { left: "Concert", right: "Listen to live music" },
            { left: "Museum", right: "See art/history" },
            { left: "Theater", right: "Watch plays/shows" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 8: EVER, NEVER, BEFORE - TIME MARKERS (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s8",
      title: "Set 8: Time Markers Advanced",
      questions: [
        {
          type: "mc",
          q: "'Have you ___ tried caviar?' (asking about life experience)",
          options: ["ever", "never", "already"],
          a: "ever",
          tip: "EVER = alguna vez (questions)",
          successtip: "✓EVER!\nEver en preguntas = ¿alguna vez? 🤔\nNativos lo usan TODO el tiempo\nCaviar = caviar 🐟 (luxury food)"
        },
        {
          type: "order",
          q: "Context: Nunca has estado en África. Traduce: Nunca he estado en África.",
          words: ["I've", "never", "been", "to", "Africa."],
          a: "I've never been to Africa.",
          tip: "NEVER = nunca (strong negative)",
          successtip: "✓NEVER!\nNever con Perfect = en toda tu vida 💯\nMás enfático que 'haven't'"
        },
        {
          type: "input",
          q: "'I've been to Australia ___.' (at some point in the past)",
          a: "before",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓BEFORE!\nBefore = antes/alguna vez 📅\nGoes at END of sentence\n'I've done it before' = común"
        },
        {
          type: "mc",
          q: "'I've never ___ sushi.' Which fits?",
          options: ["tried", "try", "trying"],
          a: "tried",
          tip: "NEVER + past participle",
          successtip: "✓NEVER TRIED!\n'Never tried' = nunca probado 🍣\nSuper común con comida\n'I've never tried X' = conversación típica"
        },
        {
          type: "order",
          q: "Context: Preguntando si alguna vez vio aurora boreal. Traduce: ¿Alguna vez has visto la aurora boreal?",
          words: ["Have", "you", "ever", "seen", "the", "Northern", "Lights?"],
          a: "Have you ever seen the Northern Lights?",
          tip: "EVER in questions = alguna vez"
        },
        {
          type: "mc",
          q: "'He's ___ been abroad.' (zero times in his life)",
          options: ["never", "ever", "always"],
          a: "never",
          tip: "NEVER = not even once",
          successtip: "✓NEVER BEEN ABROAD!\nNever been abroad = nunca salió del país 🚫✈️\nCommon with people who don't travel"
        },
        {
          type: "input",
          q: "'Have you ___ ridden a motorcycle?' (in your life - question)",
          a: "ever",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓MOTORCYCLE!\nMotorcycle = motocicleta 🏍️\n🇺🇸 'Motorcycle'\n🇬🇧 'Motorbike' también"
        },
        {
          type: "order",
          q: "Context: Esta es tu primera vez en Nueva York. Traduce: Nunca he estado en Nueva York antes.",
          words: ["I've", "never", "been", "to", "New", "York", "before."],
          a: "I've never been to New York before.",
          tip: "NEVER...BEFORE = emphasis (first time)",
          successtip: "✓BEFORE al final!\n'Never...before' = énfasis extra 💥\n'This is my first time' = otra forma"
        },
        {
          type: "mc",
          q: "Most natural: 'Is this your first time here?'",
          options: ["'Yes, I've never been here before.'", "'Yes, I never was here before.'", "'Yes, I didn't be here before.'"],
          a: "'Yes, I've never been here before.'",
          successtip: "✓FIRST TIME!\n'Never been...before' = respuesta perfecta a 'First time?' ✓\nNativos dicen esto exactly"
        },
        {
          type: "match",
          q: "Match time markers to usage",
          pairs: [
            { left: "ever", right: "Questions (Have you ever...?)" },
            { left: "never", right: "Strong negative (I've never...)" },
            { left: "before", right: "At end (I've been...before)" }
          ],
          a: "completed"
        }
      ]
    },

    // ===================================================================
    // SET 9: ADVANCED CONVERSATION PATTERNS (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s9",
      title: "Set 9: Natural Conversations",
      questions: [
        {
          type: "mc",
          q: "A: 'I've been to 30 countries!' B: Most natural response:",
          options: ["'Wow! Which one was your favorite?'", "'Wow! Which one has been your favorite?'", "'Wow! Which one is your favorite?'"],
          a: "'Wow! Which one was your favorite?'",
          tip: "Asking about specific past = PAST SIMPLE",
          successtip: "✓FAVORITE!\nFavorite question → always Past Simple 🎯\n'Was' not 'is' or 'has been'\nNativos siempre así"
        },
        {
          type: "order",
          q: "Context: Reaccionando a experiencia ajena. Traduce: Eso suena increíble.",
          words: ["That", "sounds", "amazing."],
          a: "That sounds amazing.",
          tip: "SOUNDS amazing (present reaction)",
          successtip: "✓SOUNDS!\n'Sounds amazing/awesome/cool' = respuesta típica 😍\nNatural reaction a historias de viajes"
        },
        {
          type: "mc",
          q: "A: 'Have you been to Thailand?' B: 'Yes!' A: 'Lucky you! ___?'",
          options: ["What did you see there?", "What have you seen there?", "What are you seeing there?"],
          a: "What did you see there?",
          tip: "Specific trip details = PAST SIMPLE",
          successtip: "✓LUCKY YOU!\n'Lucky you!' = ¡qué suerte! 🍀\nNative expression común\nFollowed by past simple question"
        },
        {
          type: "input",
          q: "Natural reaction: 'I'd love to ___ that someday!' (try in future)",
          a: "try",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["do", "experience"] },
          successtip: "✓I'D LOVE TO!\n'I'd love to...' = me encantaría 💭\nPolite way to show interest\nSomeday = algún día"
        },
        {
          type: "order",
          q: "Context: Ofreciendo consejo basado en experiencia. Traduce: Deberías ir si tienes la oportunidad.",
          words: ["You", "should", "go", "if", "you", "get", "the", "chance."],
          a: "You should go if you get the chance.",
          successtip: "✓GET THE CHANCE!\n'Get the chance' = tener la oportunidad 🎯\n'If you get the chance' = advice phrase común"
        },
        {
          type: "mc",
          q: "A: 'I've been skydiving!' B: 'Really? Weren't you ___?'",
          options: ["scared?", "scaring?", "scary?"],
          a: "scared?",
          tip: "SCARED = asustado (feeling)",
          successtip: "✓SCARED!\nScared = asustado 😨\nScary = que asusta 👻\nDifferent!\n'Weren't you scared?' = typical follow-up"
        },
        {
          type: "input",
          q: "Story ending: 'It was ___ an experience!' (unforgettable - positive)",
          a: "quite",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["such", "really"] },
          successtip: "✓QUITE AN EXPERIENCE!\n'Quite an experience' = toda una experiencia 💫\nBritish expression, now worldwide\nUnderstatement style"
        },
        {
          type: "order",
          q: "Context: Mostrando envidia sana. Traduce: ¡Estoy tan celoso!",
          words: ["I'm", "so", "jealous!"],
          a: "I'm so jealous!",
          successtip: "✓SO JEALOUS!\n'So jealous!' = ¡qué envidia! 😭\nPlayful, not serious jealousy\nReaction común a travel stories"
        },
        {
          type: "mc",
          q: "Pattern: Comparing experiences: 'I've been to Paris. ___ been to London?'",
          options: ["Have you", "Did you", "Are you"],
          a: "Have you",
          tip: "Comparing experiences = both Present Perfect",
          successtip: "✓COMPARISON!\nDos experiences = dos Perfect 🎯\nKeeps conversation in same tense\nSounds natural"
        },
        {
          type: "match",
          q: "Match conversational responses",
          pairs: [
            { left: "Excitement", right: "That sounds amazing!" },
            { left: "Interest", right: "I'd love to try that!" },
            { left: "Playful envy", right: "I'm so jealous!" }
          ],
          a: "completed",
          successtip: "✓REACTIONS!\nEstas 3 = respuestas TOP a travel stories 💬\nNativos las usan constantly"
        }
      ]
    },

    // ===================================================================
    // SET 10: MASTERY - STORYTELLING (10 preguntas)
    // ===================================================================
    {
      id: "m6-u8-s10",
      title: "Set 10: Experience Mastery",
      questions: [
        {
          type: "mc",
          q: "Opening a travel story naturally: '___'",
          options: ["I've been to some amazing places.", "I went to some amazing places.", "I go to amazing places."],
          a: "I've been to some amazing places.",
          tip: "Starting with general experience = PERFECT",
          successtip: "✓STORY OPENING!\nPerfect sets the stage 🎭\nThen Simple tells details\nNative storytelling structure 💯"
        },
        {
          type: "mc",
          q: "Bucket list item: 'One place I've ___ been to is Iceland.'",
          options: ["always wanted to go but never", "always gone", "always went"],
          a: "always wanted to go but never",
          tip: "BUCKET LIST = things you want to do",
          successtip: "✓BUCKET LIST!\nBucket list = lista de deseos antes de morir 🪣\nCultural reference: 'kick the bucket' = die\nVery common native concept"
        },
        {
          type: "order",
          q: "Context: Dando overview de tus viajes. Traduce: He visitado 15 países hasta ahora.",
          words: ["I've", "visited", "15", "countries", "so", "far."],
          a: "I've visited 15 countries so far.",
          tip: "SO FAR = hasta ahora (with present perfect)",
          successtip: "✓SO FAR!\n'So far' = hasta ahora ⏰\nImplies: and counting!\nShows experience is ongoing"
        },
        {
          type: "mc",
          q: "Advanced: 'If I could go anywhere, I ___ choose...'",
          options: ["would", "will", "have"],
          a: "would",
          tip: "WOULD = hypothetical choice",
          successtip: "✓WOULD!\n'I would...' = hypothetical 💭\nConversation game común\n'If you could go anywhere...' = classic question"
        },
        {
          type: "input",
          q: "Must-visit: 'Paris is definitely ___ the trip!' (worth traveling for)",
          a: "worth",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "✓WORTH IT!\n'Worth the trip' = vale la pena el viaje 💎\n'Worth it' = native phrase súper común\nWorth the time/money/effort"
        },
        {
          type: "order",
          q: "Context: Recomendando destino enfáticamente. Traduce: ¡Tienes que ir allá!",
          words: ["You", "have", "to", "go", "there!"],
          a: "You have to go there!",
          successtip: "✓HAVE TO!\n'You have to...' = tienes que (strong recommendation) 💪\nFor places you LOVED\n'You must...' también funciona"
        },
        {
          type: "mc",
          q: "Experience highlight: 'The highlight of my trip ___...'",
          options: ["was", "has been", "is"],
          a: "was",
          tip: "Specific past trip = PAST SIMPLE",
          successtip: "✓HIGHLIGHT!\nHighlight = lo mejor/punto culminante ⭐\n'The highlight was...' = storytelling phrase\nFollowed by best part"
        },
        {
          type: "mc",
          q: "Rating experience: 'On a scale of 1 to 10, I'd give it ___'",
          options: ["an 8", "8", "the 8"],
          a: "an 8",
          tip: "GIVE IT = calificar",
          successtip: "✓SCALE!\n'On a scale of 1-10' = rating method 📊\n'Give it a/an X' = article needed!\n'10 out of 10' = otra forma"
        },
        {
          type: "order",
          q: "Context: Describiendo viaje como increíble. Traduce: Fue el viaje de mi vida.",
          words: ["It", "was", "the", "trip", "of", "a", "lifetime."],
          a: "It was the trip of a lifetime.",
          successtip: "✓LIFETIME!\n'Trip of a lifetime' = viaje de tu vida 🌟\nSuperlative expression\nOnce-in-a-lifetime experience"
        },
        {
          type: "mc",
          q: "FINAL MASTERY: Most natural travel conversation:",
          options: ["'Have you ever been abroad?' 'Yes! I went to Spain last year. It was incredible!'", "'Did you ever go abroad?' 'Yes! I have gone to Spain last year.'", "'Are you ever abroad?' 'Yes! I'm going to Spain.'"],
          a: "'Have you ever been abroad?' 'Yes! I went to Spain last year. It was incredible!'",
          successtip: "✓UNIT 8 COMPLETE! 🎉🏆\n\nMAESTRÍA ALCANZADA:\n✓ HAVE YOU EVER...? (experiencias)\n✓ Present Perfect → Past Simple flow\n✓ BEEN vs GONE (crítico!)\n✓ Ever / Never / Before\n✓ 60+ VOCABULARY ITEMS:\n  🏖️ Vacaciones: cruise, backpacking, resort, road trip\n  🪂 Extreme: skydiving, bungee, scuba, rock climbing\n  🎭 Cultura: concerts, theater, museums, festivals\n  🎢 Parks: amusement, theme, water, national\n✓ Conversational reactions:\n  • That sounds amazing!\n  • I'm so jealous!\n  • I'd love to try that!\n  • You have to go there!\n✓ Storytelling phrases:\n  • Trip of a lifetime\n  • Worth the trip\n  • Highlight of my trip\n  • So far / Before\n✓ B1→B2 level:\n  • Native patterns\n  • Cultural insights\n  • Natural flow\n  • Advanced collocations\n\nPuedes ahora:\n🌍 Hablar de viajes como nativo\n🗣️ Contar historias naturalmente\n❓ Preguntar experiencias correctly\n✈️ Usar 60+ travel/adventure words\n🎯 Cambiar Perfect→Simple fluidly\n💬 Reaccionar auténticamente\n📖 Estructurar narrativas\n🚀 NIVEL B2 en conversaciones!\n\n¡Increíble progreso! 🌟\nReady for Module 6 Final Review! 🎊"
        }
      ]
    }
  ],

  // ===================================================================
  // READING SET - PROGRESSIVE FORMAT (10 preguntas)
  // ===================================================================
  readingSet: {
    id: "m6-u8-reading",
    title: "Reading Practice - Travel Stories",
    category: "reading",
    
    questions: [
      // BLOQUE 1: Online Forum Opening
      {
        type: "passage",
        passage: `**Travel Forum: Share Your Best Trip!**

**Topic: What's the most amazing place you've ever been to?**

**User: @WanderlustMike**
Hey everyone! I've been lurking on this forum for months, and I've seen so many incredible travel stories. Time for me to share mine!

Have you ever been to New Zealand? I went last year, and it was the trip of a lifetime. I've traveled to 23 countries so far, but New Zealand was on another level.

I've been skydiving, bungee jumping, and paragliding – all in the span of one week! Queenstown is the adventure capital of the world. If you're into extreme sports, you HAVE to go there.

Anyone else been to NZ? Would love to hear your stories!`
      },
      {
        type: "mc",
        q: "Why does Mike use 'I've traveled to 23 countries so far'?",
        options: ["Present Perfect shows ongoing experience (can travel more)", "Past Simple for finished action", "Future tense for plans"],
        a: "Present Perfect shows ongoing experience (can travel more)",
        tip: "'So far' = hasta ahora (ongoing)",
        successtip: "✓SO FAR!\n'So far' siempre con Perfect 💯\nImplica: la cuenta sigue"
      },
      {
        type: "mc",
        q: "Mike uses Past Simple 'I went' because:",
        options: ["He's giving specific details about WHEN (last year)", "It's a general experience", "He's still there"],
        a: "He's giving specific details about WHEN (last year)",
        successtip: "✓PERFECT → SIMPLE!\nPerfect abre → Simple detalla ✓\nPattern correcto 🎯"
      },

      // BLOQUE 2: Response 1
      {
        type: "passage",
        passage: `**User: @TravelingTina**
@WanderlustMike OMG, I'm so jealous! I've always wanted to go to New Zealand but I've never been able to save enough money. It's definitely on my bucket list.

I've been to Australia though! I went three years ago and did the Great Ocean Road. Have you ever driven along a coastal highway? It's incredible – ocean on one side, cliffs on the other.

I've never been bungee jumping. Weren't you scared?? I'm terrified of heights, so skydiving is probably never going to happen for me 😅

What was your favorite activity in Queenstown?`
      },
      {
        type: "mc",
        q: "Tina says 'I've never been able to save enough.' This means:",
        options: ["Up until now, she hasn't saved enough (ongoing situation)", "One time in the past she didn't save", "In the future she won't save"],
        a: "Up until now, she hasn't saved enough (ongoing situation)",
        tip: "'Never' with Perfect = en toda tu vida hasta ahora"
      },
      {
        type: "mc",
        q: "When Tina says 'I went three years ago', she switches to Past Simple because:",
        options: ["She's giving a specific time", "It's more natural", "Present Perfect doesn't work"],
        a: "She's giving a specific time",
        successtip: "✓SPECIFIC TIME!\nTiempo específico = Simple ALWAYS 📅"
      },

      // BLOQUE 3: Response 2
      {
        type: "passage",
        passage: `**User: @AdventureAlex**
New Zealand crew checking in! I've been to the South Island twice. Both times I based myself in Queenstown.

@TravelingTina – I've done the bungee jump there, and yes, I was terrified! But it was SO worth it. That adrenaline rush was insane. I'd love to do it again someday.

@WanderlustMike – Have you been to Milford Sound? I went on a cruise there during my first trip. The fjords are breathtaking. It rained the whole time, but the guide said "If you haven't seen Milford Sound in the rain, you haven't really seen it." So true!

BTW, has anyone here ever been backpacking through Southeast Asia? I'm planning a trip for next year.`
      },
      {
        type: "mc",
        q: "Alex says 'I've been to the South Island twice.' Why Present Perfect?",
        options: ["Counting life experiences (total number)", "Talking about a specific trip", "Describing ongoing action"],
        a: "Counting life experiences (total number)",
        successtip: "✓COUNTING!\nExperiencias numéricas = Perfect 🔢\n'Once/twice/three times' etc."
      },
      {
        type: "mc",
        q: "'I went on a cruise during my first trip' – Why Past Simple?",
        options: ["Specific trip in the past (first trip)", "General experience", "Current situation"],
        a: "Specific trip in the past (first trip)",
        tip: "'During my first trip' = specific past time"
      },

      // BLOQUE 4: Response 3
      {
        type: "passage",
        passage: `**User: @WanderlustMike**
@TravelingTina – Don't worry about the money! I backpacked through Southeast Asia on $30/day. It's super affordable. You should definitely do that before splurging on New Zealand!

Favorite activity? Honestly, the bungee was the highlight. I've been to amusement parks with crazy roller coasters, but nothing compares to jumping off a bridge 😂

@AdventureAlex – No, I haven't been to Milford Sound yet. I was only there for 10 days, and I ran out of time. That's why I said "so far" earlier – I'm definitely going back!

And yes! I've backpacked through Thailand, Vietnam, and Cambodia. Best decision ever. The food, the culture, the beaches... Thailand especially. Have you ever been to Thailand?`
      },
      {
        type: "mc",
        q: "Mike says 'I haven't been to Milford Sound yet.' This means:",
        options: ["He plans to go (it's still possible in the future)", "He went but didn't like it", "He'll never go"],
        a: "He plans to go (it's still possible in the future)",
        successtip: "✓YET!\n'Haven't...yet' = todavía no, pero maybe later ⏰\nImplies future possibility"
      },
      {
        type: "mc",
        q: "'I was only there for 10 days' – Why Past Simple?",
        options: ["Finished time period in the past", "Ongoing duration", "Future plan"],
        a: "Finished time period in the past",
        tip: "Completed duration = Past Simple"
      },

      // PREGUNTAS FINALES
      {
        type: "mc",
        q: "Throughout the forum, Present Perfect is used for:",
        options: ["Life experiences without specific times", "All past actions", "Future plans"],
        a: "Life experiences without specific times",
        successtip: "✓USAGE CLEAR!\nPerfect = experiencia general ✓\nSimple = detalles específicos ✓\nPattern perfectamente shown"
      },
      {
        type: "mc",
        q: "The conversation flow pattern is:",
        options: ["Perfect (experience?) → Simple (details!)", "Simple → Perfect → Simple", "Only Perfect throughout"],
        a: "Perfect (experience?) → Simple (details!)",
        successtip: "✓READING COMPLETE! 🎉\n\nPATTERNS VISTOS:\n✓ Have you ever...? (preguntas)\n✓ I've been to... (experiencias)\n✓ I went... (detalles específicos)\n✓ Ever/Never/Yet (time markers)\n✓ So far (ongoing count)\n\nVOCABULARY EN CONTEXTO:\n🏔️ New Zealand, Queenstown, Milford Sound\n🪂 Skydiving, bungee, paragliding\n🌊 Cruise, coastal highway, fjords\n🎒 Backpacking, bucket list\n💰 Save money, afford, splurge\n🎢 Adrenaline rush, highlight\n\nCONVERSATIONAL PHRASES:\n• I'm so jealous!\n• Trip of a lifetime\n• On my bucket list\n• Worth it\n• Have to go there\n• So true!\n\nGRAMATICAL INSIGHTS:\n✓ Perfect para establecer experiencia\n✓ Simple para dar detalles/tiempo\n✓ Natural code-switching entre ambos\n✓ Native-level conversation flow\n\n¡Entendiste conversación auténtica de nativos! 🌟"
      }
    ]
  },

  // ===================================================================
  // REVIEW SET (10 preguntas)
  // ===================================================================
  reviewSet: {
    id: "m6-u8-review",
    title: "Unit Review - Experience Mastery",
    category: "review",
    exercises: [
      {
        type: "mc",
        q: "REVIEW: Ask about life experience:",
        options: ["Have you ever been to Paris?", "Did you ever go to Paris?", "Do you ever go to Paris?"],
        a: "Have you ever been to Paris?",
        tip: "Life experience = HAVE EVER"
      },
      {
        type: "mc",
        q: "REVIEW: Short answer to 'Have you ever...?' YES:",
        options: ["Yes, I have.", "Yes, I did.", "Yes, I've been."],
        a: "Yes, I have."
      },
      {
        type: "mc",
        q: "REVIEW: BEEN vs GONE – 'She's ___ to Italy.' (has the experience now)",
        options: ["been", "gone", "went"],
        a: "been",
        tip: "Experience + returned = BEEN"
      },
      {
        type: "mc",
        q: "REVIEW: BEEN vs GONE – 'He's ___ to the store.' (not here now)",
        options: ["gone", "been", "went"],
        a: "gone",
        tip: "Away now = GONE"
      },
      {
        type: "mc",
        q: "REVIEW: Follow-up question after 'Yes, I have':",
        options: ["When did you go?", "When have you gone?", "When do you go?"],
        a: "When did you go?",
        tip: "Details = PAST SIMPLE"
      },
      {
        type: "order",
        q: "REVIEW: Traduce: Nunca he probado sushi.",
        words: ["I've", "never", "tried", "sushi."],
        a: "I've never tried sushi.",
        tip: "NEVER = strong negative"
      },
      {
        type: "mc",
        q: "REVIEW: ERROR – Which is WRONG?",
        options: ["I have been there last year.", "I went there last year.", "I've been there before."],
        a: "I have been there last year.",
        tip: "⚠️ Perfect + specific time = ERROR",
        successtip: "🚨 NEVER Perfect + tiempo específico!"
      },
      {
        type: "input",
        q: "REVIEW: 'Have you ___ been skydiving?' (alguna vez)",
        a: "ever",
        accept: { ignoreCase: true, ignorePunctuation: true }
      },
      {
        type: "match",
        q: "REVIEW: Match vocabulary categories",
        pairs: [
          { left: "Vacation", right: "cruise, resort, backpacking" },
          { left: "Extreme sports", right: "skydiving, bungee, scuba" },
          { left: "Culture", right: "concert, museum, theater" }
        ],
        a: "completed"
      },
      {
        type: "mc",
        q: "FINAL REVIEW: Natural travel conversation:",
        options: ["'Have you been to Spain?' 'Yes! I went last summer.'", "'Did you go to Spain?' 'Yes! I have gone last summer.'", "'Have you gone to Spain?' 'Yes! I went.'"],
        a: "'Have you been to Spain?' 'Yes! I went last summer.'",
        successtip: "✓UNIT 8 MASTERY! 🎉🏆\n\nTODO DOMINADO:\n✓ Have you ever...?\n✓ Present Perfect para experiencias\n✓ Past Simple para detalles\n✓ BEEN vs GONE\n✓ Ever/Never/Before/So far/Yet\n✓ Perfect → Simple conversation flow\n✓ 60+ travel/adventure vocabulary\n✓ Native reactions y phrases\n✓ Storytelling structures\n✓ B2-level conversations!\n\n¡MÓDULO 6 CASI COMPLETO!\nReady for final unit! 🚀"
      }
    ]
  }
};
